export const inr = (n) => {
  const v = Number(n || 0);
  return "₹" + v.toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

export const inrShort = (n) => {
  const v = Number(n || 0);
  const abs = Math.abs(v);
  const sign = v < 0 ? "-" : "";
  if (abs >= 10000000) return `${sign}₹${(abs / 10000000).toFixed(2)}Cr`;
  if (abs >= 100000) return `${sign}₹${(abs / 100000).toFixed(2)}L`;
  if (abs >= 1000) return `${sign}₹${(abs / 1000).toFixed(1)}K`;
  return `${sign}₹${abs}`;
};

export const pct = (n) => `${Number(n || 0).toFixed(1)}%`;

export const statusClass = (status) => {
  const s = String(status || "").toLowerCase();
  const green = ["paid", "approved", "disbursed", "active", "under budget", "achieved", "on budget"];
  const red = ["overdue", "rejected", "over budget", "inactive", "missed"];
  const amber = ["pending", "applied", "under review", "researching", "revised", "in progress"];
  if (green.includes(s)) return "bg-emerald-600/15 text-emerald-400 border border-emerald-600/30";
  if (red.includes(s)) return "bg-rose-600/15 text-rose-400 border border-rose-600/30";
  if (amber.includes(s)) return "bg-amber-500/15 text-amber-400 border border-amber-500/30";
  return "bg-slate-600/20 text-slate-300 border border-slate-600/30";
};

export const ragColor = (rag) =>
  rag === "green" ? "#059669" : rag === "amber" ? "#D97706" : "#DC2626";
